// =========================
// lib - core index
// =========================

// General
module.exports = require("./general.js");
module.exports.hash = require("./hash.js");

// Collections: TODO: maybe remove Collections prefix
module.exports.Collections = require("./collections");

// Observable:
module.exports.ObservableValue = require("./observable/observableValue.js");
module.exports.ObservableMap = require("./observable/observableMap.js");
module.exports.ObservableSet = require("./observable/observableSet.js");
module.exports.ObservableList = require("./observable/observableList.js");
module.exports.ObservableTreeNode = require("./observable/tree/observableTreeNode.js");
module.exports.ObservableShadow = require("./observable/observableShadow.js");
module.exports.ObservableCachedFunction = require("./observable/observableCachedFunction.js");

module.exports.ObservableTreeSet = require("./observable/tree/observableTreeSet.js");

// DataModel
module.exports.Root = require("./datamodel/root.js");
module.exports.DataRoot = require("./datamodel/dataRoot.js");
module.exports.NonShareableDataRoot = require("./datamodel/nonShareableDataRoot.js");
module.exports.ModelRoot = require("./datamodel/modelRoot.js");
module.exports.DescriptionRoot = require("./datamodel/descriptionRoot.js");

// Root Extensions
module.exports.GlobalUid = require("./datamodel/globalUid.js");
module.exports.LocalUid = require("./datamodel/localUid.js");
module.exports.JsonParser = require("./datamodel/jsonParser.js");
module.exports.Undoable = require("./datamodel/undoable.js");
module.exports.Shareable = require("./datamodel/shareable.js");
module.exports.Hashifier = require("./datamodel/hashifier.js");

module.exports.AbstractInstance = require("./datamodel/instanceBuilder/abstractInstance.js");
module.exports.InstanceBuilder = require("./datamodel/instanceBuilder/instanceBuilder.js");
